export const GENERIC_FAILURE_TITLE = 'Uh oh...';

export const GENERIC_FAILURE_MESSAGE = 'There was an error processing your request. We\'re investigating. Please try again, or contact the restaurant directly to place an order.';
export const REQUEST_FAILURE_MESSAGE = 'There was an error processing your request. Please try again, or contact the restaurant directly to place an order.';
